"use client"
import { VoucherStatus } from "@/api/Voucher"
import { createContext, ReactNode, useContext, useEffect, useState } from "react"

export interface GiftcardDataContext extends VoucherStatus {
  id: string
}

interface GiftcardContextValue {
  giftcard?: GiftcardDataContext
  setGiftcard: (data: GiftcardDataContext) => void
  clearGiftcard: () => void
}

const GiftcardContext = createContext<GiftcardContextValue>({
  setGiftcard: () => {},
  clearGiftcard: () => {},
})

export const GiftcardProvider = ({ children }: { children: ReactNode }) => {
  const [giftcard, setGiftcardState] = useState<GiftcardDataContext | undefined>()

  useEffect(() => {
    const stored = sessionStorage.getItem("giftcard")
    if (stored) setGiftcardState(JSON.parse(stored))
  }, [])

  const setGiftcard = (data: GiftcardDataContext) => {
    setGiftcardState(data)
    sessionStorage.setItem("giftcard", JSON.stringify(data))
  }

  const clearGiftcard = () => {
    setGiftcardState(undefined)
    sessionStorage.removeItem("giftcard")
  }

  return (
    <GiftcardContext.Provider value={{ giftcard, setGiftcard, clearGiftcard }}>{children}</GiftcardContext.Provider>
  )
}

export const useGiftcard = () => useContext(GiftcardContext)
